import React, { FC } from 'react';
import moment from 'moment';
import { Box, Button, Grid, GridItem } from '@chakra-ui/react';

import { StandFormInstance } from './types';
import SelectField from '../common/select-field';
import FieldView from '../common/field-view';
import { USER_DATE_FORMAT } from '../../utils/constants';
import { useGuide } from '../../hooks/use-guide';

interface StandFormProps {
  instance: Partial<StandFormInstance>;
  submitText?: string;
  onChange(field: string): (value: unknown) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

const StandForm: FC<StandFormProps> = (props) => {
  const { instance, onChange, submitText, onSubmit, onCancel } = props;

  return (
    <Grid templateColumns={{ base: '1fr' }} gap={5}>
      <GridItem >
        <FieldView title="Торговая точка" value={instance?.outlet?.name} />
        <FieldView
          title="Дата установки"
          value={
            instance?.update_dt
              ? moment(instance?.mount_date).format(USER_DATE_FORMAT)
              : 'не указано'
          }
        />
        <FieldView
          title="Дата последнего посещения"
          value={
            instance?.update_dt
              ? moment(instance?.update_dt).format(USER_DATE_FORMAT)
              : 'не указано'
          }
        />
      </GridItem>
      <GridItem >
        <SelectField
          id="stand_model"
          name="stand_model"
          label="Модель"
          value={instance.model || undefined}
          options={instance.model ? [instance.model] : []}
          onFetchOptions={useGuide(
            'stand_model' /* , equip.type?.id && equip.brand?.id ? {equip_model_id: '' + equip.type.id, stand_brand_id: '' + equip.brand.id} : undefined*/
          )}
          onChange={onChange('model')}
        ></SelectField>
      </GridItem>
      <GridItem >
        <Box display="flex" justifyContent="space-between">
          <Button
            colorScheme="brand"
            onClick={onSubmit}
          >
            {submitText || 'Создать'}
          </Button>
          <Button
            variant="ghost"
            onClick={onCancel}
          >
            Отмена
          </Button>
        </Box>
      </GridItem>
    </Grid>
  );
};

export default StandForm;
